export default "__VITE_ASSET__6onb1PU3__"